import React, { forwardRef, InputHTMLAttributes } from 'react'
import { FieldError } from 'react-hook-form'
import { hashString } from '../../utils/hash'

import "./InputField.scss"
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  errors?: FieldError
  label?: string
  required?: boolean
  transparent?: boolean
}

const InputField = forwardRef<HTMLInputElement, InputProps>(({label, required, transparent, errors, ...rest}: InputProps, ref) => {
    const hash = "input-" + hashString(Math.random().toString()).toString().slice(-4)
    
  return (
    <div className='input'>   
        <input  id={hash} placeholder={label} className={transparent ? 'transparent' : ''} ref={ref} {...rest}/>
        <label className={!!required ? 'required' : ''}  htmlFor={hash}>{label}</label>
    </div>
  )
})

export default InputField